import { Container, SkipButton,Title, Content, LogoImage, LogoWrapper, LinksContainer ,ContinueButton  } from './styles.js';
import logo from '../../assets/LogoPos2.png';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../../services/client/api';
import React, { useState, useEffect } from 'react';
import { Table } from 'reactstrap';
function Terms() {
    const location = useLocation();
    const history = useHistory();
    const [showScrollButton, setShowScrollButton] = useState(true);

    useEffect(() => {
      const handleScroll = () => {
        const scrolledToBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 70;
        setShowScrollButton(!scrolledToBottom);
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    
    const { username, verification_form, mail, tel, id } = location.state || {};
     const handleAccepted = () => {
       api().user().acceptTerms({ username });
         history.replace({
            pathname: '/info-verify',
            state: {
              username,
              verification_form,
              mail,
              tel,
              id
            },
          });
     } 

  return (

    <>
    {showScrollButton && (
    <SkipButton  onClick={() => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }}>
    Ir para o fim da página ↓
    </SkipButton>
    )}
    <LogoWrapper>
        <LogoImage onClick={() => history.replace({ pathname:"/login"})} src={logo} alt="Logo CEDAP" />
      </LogoWrapper>
    <Container>
      
   
        <Title>Termos de Uso e Política de Privacidade</Title>
        <Content>
          <h2>1. Finalidade do Sistema</h2>
          <p>
            Este sistema é disponibilizado pelo <strong>Centro de Diagnósticos Anátomo Patológicos - Cedap</strong> para que pacientes, médicos solicitantes e profissionais autorizados possam acessar, de forma segura e eficiente, os laudos laboratoriais de patologia.
          </p>

          <h2>2. Acesso e Responsabilidades</h2>
          <p>
            O acesso é pessoal, intransferível e protegido por credenciais individuais (login e senha). O usuário se compromete a manter seus dados de acesso em sigilo, responsabilizando-se por quaisquer ações realizadas a partir de sua conta.
          </p>
          <p>
            O paciente autoriza o tratamento de seus dados pessoais e sensíveis conforme a Lei Geral de Proteção de Dados Pessoais (LGPD - Lei nº 13.709/2018), exclusivamente para fins diagnósticos e assistenciais.
          </p>

          <h2>3. Sigilo e Proteção de Dados</h2>
          <p>
            Todas as informações acessadas são protegidas por sigilo profissional e não podem ser divulgadas sem autorização, salvo nos casos previstos em lei.
          </p>
          <p>
            O laboratório adota criptografia, controle de acesso e auditorias periódicas para garantir a segurança.
          </p>

          <h2>4. Limitação de Responsabilidade</h2>
          <p>
            O laboratório não se responsabiliza por uso inadequado do sistema, negligência com as credenciais ou acessos indevidos.
          </p>

          <h2>5. Condições de Uso</h2>
          <ul>
            <li>É proibido tentar acessar contas de terceiros ou áreas restritas.</li>
            <li>É proibido copiar ou divulgar informações sem autorização.</li>
          </ul>

          <h2>6. Penalidades</h2>
          <p>
            O descumprimento pode resultar em bloqueio do acesso e responsabilização legal.
          </p>

              <h2>7. Direitos do Titular</h2>
          <ul>
            <li>Acesso, correção, anonimização ou exclusão dos dados.</li>
            <li>Revogação de consentimento e portabilidade.</li>
          </ul>


          <h3>Política de Privacidade</h3>
          <p>
          Quando você acessa nosso website, o navegador coleta dados pessoais e os envia para nossos servidores. Além disso, ao utilizar nossos serviços, você poderá ser solicitado a fornecer dados adicionais. 
          </p>

          <p>
            Assim, o objetivo deste aviso, é informar ao titular quais dados seus são coletados, quando são coletados, qual o tratamento dado, como é a forma de armazenamento, se há compartilhamento com terceiros, entre outras informações essenciais em relação aos dados pessoais.
          </p>

          <p>
            A garantia da confidencialidade dos dados pessoais dos usuários do nosso portal é tratada como prioridade por todos do time Centro de Diagnósticos Anátomo Patológicos - CEDAP.
          </p>

          <p>
            A seguir, apresentamos informações de como tratamos seus dados pessoais quando você usa nosso Website. Salvo indicação em contrário nos capítulos seguintes, a base jurídica para o tratamento de seus dados pessoais resulta do fato de que esse tratamento é necessário para disponibilizar as funcionalidades do Website solicitado por você (Lei Geral de Proteção de Dados, No. 13.709/2018, Art. 7, V).
          </p>

            <Table striped bordered responsive style={{ marginTop: '5px' }}>
            <thead>
              <tr>
             
                <th>Quando coletamos dados</th>
                <th>Por que coletamos</th>
                <th>Quais dados coletamos</th>
                <th>Retenção</th>
              </tr>
            </thead>
            <tbody>
              <tr>
              
                <td>Utilização do website</td>
                <td>
                Quando você navega em nosso website, o navegador coleta e transfere alguns dados para nosso servidor. A razão deste tratamento é técnica para garantir que as funcionalidades do site sejam executadas corretamente, permitindo uma melhor navegação.
                </td>
                <td>
                  Endereço IP, data/hora do acesso, fuso horário, conteúdo da solicitação, status HTTP, volume de dados transferidos.
                </td>
                <td>
                Para proteção de nossos legitimos interesses, nós armazenamos esses dados por um período limitado para poder iniciar um rastreamento de dados pessoais no caso de acesso real ou tentativa de acesso não autorizados aos nossos servidores (Lei 13.709/2018, Art. 7, IX).
                </td>
              </tr>
              <tr>
            
                <td>Autenticação</td>
                <td>
                Quando o usuário tenta acessar sua conta no nosso website, solicitamos o fornecimento de um nome de usuário (login) e uma senha. Esses dados são utilizados para verificar a identidade do usuário e garantir que ele tenha acesso às funcionalidades do portal de maneira segura. O tratamento dessas informações é necessário para fornecer acesso aos serviços e dados solicitados pelo usuário, além de assegurar a proteção das informações pessoais armazenadas no sistema.
                </td>
                <td>Nome de usuário (login) e senha.</td>
                <td>
                 Os dados de login e senha fornecidos pelo usuário são processados exclusivamente para validação do acesso. Após a autenticação, esses dados são descartados, não sendo armazenados permanentemente em nosso sistema. A verificação das credenciais é feita em tempo real, utilizando a base de dados para confirmação de sua autenticidade. O login e a senha não são retidos após a validação do acesso, garantindo a segurança e a confidencialidade das informações pessoais. Para proteção adicional, em conformidade com a LGPD (Art. 7, V), os registros de tentativa de login (como falhas ou sucessos) podem ser armazenados temporariamente para fins de segurança e rastreabilidade.
                </td>
              </tr>
              <tr>
              
                <td>Recuperação de senha</td>
                <td>
                Quando o paciente recebe login e senha para acesso aos exames disponibilizados em nosso website e, por ventura, esquece essas credenciais, solicitamos o fornecimento do CPF. Esse dado é utilizado para localizar, em nossa base, as informações de contato (e-mail e/ou telefone) previamente vinculadas ao titular. Após a verificação, é disponibilizado um procedimento de autenticação em dois fatores, permitindo ao usuário redefinir a senha de acesso com segurança. O tratamento desses dados é necessário para garantir a proteção do acesso individual às informações.
                </td>
                <td>CPF.</td>
                <td>
              Os dados fornecidos para a recuperação de senha não são armazenados de forma permanente após a finalização do procedimento. O CPF informado é utilizado unicamente no momento da solicitação de redefinição de senha, para validação da identidade do titular, sendo descartado logo após a conclusão do processo. Entretanto, os registros de tentativas de acesso são mantidos por período limitado, com a finalidade de garantir a segurança e rastreabilidade, em conformidade com o legítimo interesse do controlador (LGPD, Art. 7, inciso IX).
                </td>
              </tr>
              <tr>
       
                <td>Alteração de senha</td>
                <td>
              Após a conclusão bem-sucedida do processo de autenticação em dois fatores (2FA), é apresentada ao titular a interface para alteração de senha. Nessa etapa, coletamos a nova senha informada com o objetivo exclusivo de atualizar o cadastro do usuário e permitir o acesso futuro ao sistema com a nova credencial. O tratamento desse dado é necessário para garantir a continuidade do acesso seguro às informações de saúde do titular.
                </td>
                <td>Nova senha de acesso.</td>
                <td>
                A nova senha informada é imediatamente processada para atualização no banco de dados, sendo armazenada em formato seguro (criptografado/hashes, conforme as boas práticas de segurança da informação). A senha em texto simples não é armazenada nem mantida após o envio. O tratamento é limitado ao tempo necessário para efetivar a atualização da credencial. A rastreabilidade da ação (registro de alteração) pode ser mantida por período determinado, conforme o legítimo interesse do controlador na garantia da segurança da informação e prevenção de fraudes (LGPD, Art. 7, inciso IX).
                </td>
              </tr>
            </tbody>
          </Table>
       
                <h2>Cookies essenciais ou necessários</h2>
          <p>
            São cookies indispensáveis para o funcionamento adequado das Páginas do Centro de Diagnósticos Anátomo Patológicos - CEDAP. Sem esses cookies, os serviços solicitados não podem ser prestados de forma correta.
          </p>
          <p>
            Um exemplo importante desse tipo de cookie é o cookie de autenticação, utilizado para armazenar de forma segura o token de acesso gerado no momento do login. Ele permite que o usuário permaneça autenticado durante a navegação. Caso este cookie esteja desabilitado ou expire, o usuário será redirecionado automaticamente à página de login, visto que o sistema entende que a sessão foi encerrada.
          </p>
          <p>
            Estes cookies não requerem consentimento prévio, conforme previsto no Art. 7º, inciso IX da Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018), pois são estritamente necessários para a prestação do serviço solicitado pelo titular dos dados.
          </p>
          <p>
           Abaixo estão listados os cookies utilizados pelo site
          </p>
          
          <Table striped bordered responsive style={{ marginTop: '5px' }}>
            <thead>
              <tr>
                <th>Nome do Cookie</th>
                <th>Propósito</th>
                <th>Outras Informações</th>
              </tr>
            </thead>
            <tbody>
              <tr>
              
                <td>token</td>
                <td>
               Responsável por armazenar o token de autenticação após o login, garantindo a manutenção da sessão do usuário. Expira automaticamente após 60 minutos ou ao realizar logout.
                </td>
                <td>
                
                </td>
    
              </tr>
             
            </tbody>
          </Table>
         
        <h2>Segurança</h2>
          <p>
           O Centro de Diagnósticos Anátomo Patológicos - CEDAP toma todas as medidas de segurança técnicas e organizacionais necessárias para proteger seus dados pessoais contra cancelamento não intencional ou ilegal, alteração, ou melhor, perda, transferência não autorizada e acesso não autorizado. Todos os dados entre o cliente e o servidor web são transmitidos de forma criptografada.
          </p>

          <p>
            Tratamos a segurança dos seus dados pessoais com o máximo de cuidado, utilizando padrões e melhores práticas adotados no mercado. Temos uma equipe qualificada e responsável por garantir que o Centro de Diagnósticos Anátomo Patológicos - CEDAP adote as melhores práticas de segurança, dentre elas:
          </p>
          
           <ul>
            <li>Múltiplo fator de autenticação e/ou senha para acesso ás informações em nuvem;</li>
            <li>Armazenamento de documentos físicos em local seguro;</li>
            <li>Monitoramento contínuo do ambiente;</li>
            <li>Análises e testes contínuos de segurança da informação em nossos sistemas.</li>
          </ul>
          
          <h2>Informações sobre seus direitos</h2>
          <p>
            Os seguintes direitos estão disponíveis para você de acordo com as legislações de privacidade de dados aplicáveis:
          </p>

           <ul>
            <li>Direito de informação sobre seus dados pessoais armazenados por nós;</li>
            <li>Direito de solicitar a correção, exclusão ou processamento restrito de seus dados pessoais;</li>
            <li>Direito de se opor a um processamento por razões de nosso interesse legítimo, interesse público ou criação de perfil, a menos que possamos provar que existem razões convincentes e justificadas que substituem seus interesses, direitos e liberdade, ou que esse processamento é feito para os fins da afirmação, exercício ou defesa de reivindicações legais;</li>
            <li>Direito à portabilidade de dados;</li>
            <li>Direito de registrar uma reclamação com uma autoridade de proteção de dados;</li>
            <li>Você pode, a qualquer momento, com efeito futuro, revogar seu consentimento para a coleta, processamento e uso de seus dados pessoais. Para mais informações, consulte os capítulos acima, descrevendo o processamento de dados com base no seu consentimento.</li>
          </ul>

          <h2>Contato</h2>

          <p>
            Dúvidas? Contate o Encarregado de Proteção de Dados pelo e-mail: <strong>cedap@cedap.com.br</strong> ou telefone: <strong>+55 47 99186-5855</strong>.
          </p>

          <h2>Atualização do Aviso de Privacidade</h2>

          <p>Podemos atualizar nosso aviso de Privacidade periodicamente. As atualizações serão publicadas em nosso site e entrarão em vigor após a publicação. Recomendamos que você o visite regularmente para se manter informado sobre possíveis alterações.</p>

          <p><em>Rua Mário Lobo 61, sala 7 Térreo<br /> Joinville - SC</em></p>
          <p><em>Última atualização: 23 de junho de 2025.</em></p>
        </Content>
   
    </Container>
<LinksContainer>
  <ContinueButton onClick={handleAccepted}>
    Li e concordo com os termos ✓
  </ContinueButton>
</LinksContainer>

    </>
  );
}

export default Terms;
